import { leadsImportHeadersRetrieveOptions } from '@crm/api'
import { useQuery } from '@tanstack/react-query'
import { DefaultOptionType } from 'antd/lib/select'
import { useMemo } from 'react'

export const useImportFieldMapping = () => {
  const { data: headers, isLoading } = useQuery({
    ...leadsImportHeadersRetrieveOptions()
  })

  const leadFields = useMemo(
    () => headers?.lead_fields ?? [],
    [headers?.lead_fields]
  )

  const contactFields = useMemo(
    () => headers?.contact_fields ?? [],
    [headers?.contact_fields]
  )

  const leadFieldMap = useMemo(
    () => Object.fromEntries(leadFields.map((f) => [f.key, f])),
    [leadFields]
  )

  const contactFieldMap = useMemo(
    () => Object.fromEntries(contactFields.map((f) => [f.key, f])),
    [contactFields]
  )

  const leadOptions: DefaultOptionType[] = useMemo(
    () => leadFields.map((item) => ({ label: item.label, value: item.key })),
    [leadFields]
  )

  const contactOptions: DefaultOptionType[] = useMemo(
    () => contactFields.map((item) => ({ label: item.label, value: item.key })),
    [contactFields]
  )

  const transform = (obj: Record<string, string>, type: 'lead' | 'contact') => {
    if (!obj) return []

    const map = type === 'lead' ? leadFieldMap : contactFieldMap

    return Object.entries(obj)
      .filter(([_, key]) => key)
      .map(([index, key]) => {
        const field = map[key]

        return {
          key,
          column_index: Number(index),
          ...(field?.custom_field_id && {
            custom_field_id: field.custom_field_id
          })
        }
      })
  }

  return {
    isLoading,
    leadFields,
    contactFields,
    leadOptions,
    contactOptions,
    leadFieldMap,
    contactFieldMap,
    transform
  }
}
